import styled from 'styled-components'

interface IInboxListNotificationMetaStyledProps {}

export const InboxListNotificationMetaStyled = styled.div<IInboxListNotificationMetaStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(12)};

  white-space: nowrap;
`
